export const getIsFull = (self) => self._els.size >= self._max_count;
